import * as React from "react";
import NotificationsSystem from "reapop";
import * as theme from "reapop-theme-bootstrap";

class Notifications extends React.PureComponent<any, any> {
  render() {
    return <NotificationsSystem theme={theme} />;
  }
}

export default Notifications;
